resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    _ContentfulCache

    Object that stores contentful cache status:
      null: not initialized yet
      syncing: sync request is sent and wait for the response. Will prevent duplicate request
      synced: stored data is up to data and ready for consuming
*/
var _ContentfulCache = {
  enableCache: false,
  status: null
};
